import { css, cx } from "@linaria/core";

import { SVG, getDefaultHeight } from "./utils";
import { easings } from "../css-tokens/easings";

type Props = {
  color?: string;
  pencilOnly?: boolean;
} & React.SVGProps<SVGSVGElement>;

const transitionCls = css`
  & > path.notebook {
    transition: opacity 0.125s linear;
  }

  & > path.pencil {
    transform-origin: bottom right;
    transition: transform 0.125s ${easings.inOutQuad},
      stroke-width 0.125s ${easings.inOutQuad};
  }

  &.pencilOnly {
    & > path.notebook {
      opacity: 0;
    }

    & > path.pencil {
      transform: scale(1.8);
      stroke-width: 1;
    }
  }
`;

export const ComplexNotebookIcon: React.FC<Props> = ({
  color = "currentColor",
  pencilOnly,
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
      className={cx(
        svgProps.className,
        transitionCls,
        pencilOnly && "pencilOnly",
      )}
      viewBox="0 0 23.267 23.387"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      <path
        className="notebook"
        d="M7.968 22.39H3a2.12 2.12 0 01-2.1-2.1M18.093 8.828V1.664A.753.753 0 0017.329.9H3.766A2.814 2.814 0 00.9 3.766V20.29a2.12 2.12 0 012.1-2.1h5.732"
      />
      <path
        className="pencil"
        d="M21.723 14.464l-7.259 7.261-3.63.764.764-3.63 7.259-7.259a2.077 2.077 0 012.866 0 1.914 1.914 0 010 2.864z"
      />
    </SVG>
  );
};
